<div style="z-index: 2" class="d-flex justify-content-center align-items-center fullPageWrapper" *ngIf="loading">
  <sb-icon class="loadingSpinnerSVG" style="font-size: 2rem" icon="loadingBlockAnimation"
           [animationOptions]="{autoplay: true, loop:true}"></sb-icon>
  <span>{{ 'lang.globals.pleaseWait' | translate }}</span>
</div>

<ng-container *ngIf="!loading">
  <div class="row">
    <div class="col-xl-6 col-12" *ngIf="shareOfVoiceMode === 'advertiser'">

        <sb-comp-embedded-campaigns [resolveCampaignData]="true"
                                    [campaigns]="reportingObj?.distinctElements?.campaign">
        </sb-comp-embedded-campaigns>
    </div>
    <div class="col-xl-3 col-md-6 col-12">
      <div class="row">
        <div class="col-12">
          <sb-card>
            <div card-header classes="no-border">
              <h3>{{ 'lang.reporting.shareOfVoice' | translate }}</h3>
              <small>{{ 'lang.reporting.from' | translate }} {{ from | date : 'dd.MM.yy' }}
                {{ 'lang.reporting.till' | translate }} {{ till | date : 'dd.MM.yy' }}</small>
            </div>
            <div card-body>
              <sb-chart #pieChart chartType="pieChart" [chartData]="pieChartData"></sb-chart>
            </div>
          </sb-card>
        </div>
        <div class="col-12">
          <sb-card>
            <div card-body classes="d-flex justify-content-center align-items-center">
              <h3>{{
                  playoutsNumber ? stringTransformation.truncateNumber(reportingObj?.report?.aggregated?.v0) :
                    parseTime(reportingObj?.report?.aggregated?.v1)
                }}</h3>
              <p class="m-0">{{ 'lang.reporting.totalPlayouts' | translate }}</p>
            </div>
          </sb-card>
        </div>
        <!--            <div class="col-6">
                      <sb-card>
                        <div card-body classes="d-flex justify-content-center align-items-center">
                          <h3>{{reportingObj?.report?.aggregated?.v3 | sbNumberFormat}}</h3>
                          <p class="m-0">Unique visitors</p>
                        </div>
                      </sb-card>
                    </div>-->
      </div>

    </div>
    <div class="col-xl-3 col-md-6 col-12">
      <div class="card card-special-shadow">
        <div class="card-fit overflow-hidden" style="height: 206px">
          <ng-container [ngSwitch]="selectedField">

            <sb-comp-medium *ngSwitchCase="'mediumGroup'" [medium]="reportingObj?.element.preview"
                            [title]="true" [customHeight]="206+'px'" [customWidth]="100+'%'"></sb-comp-medium>
            <sb-comp-medium *ngSwitchCase="'medium'" [medium]="reportingObj?.element" [title]="true"
                            [customHeight]="206+'px'" [customWidth]="100+'%'"></sb-comp-medium>
            <div *ngSwitchCase="'product'"
                 style="width: 100%; height: 100%;background-size: contain;background-position: center;background-repeat: no-repeat;"
                 [style.backgroundImage]="reportingObj?.element?.depiction?.url ?'url(' + reportingObj?.element?.depiction?.url + ')':''">
            </div>
            <div *ngSwitchCase="'productCategory'"
                 style="width: 100%; height: 100%;background-size: contain;background-position: center;background-repeat: no-repeat;"
                 [style.backgroundImage]="reportingObj?.element?.illustration?.url?'url(' + reportingObj?.element?.illustration?.url + ')':''">
            </div>
          </ng-container>

        </div>
        <div class="card-header">
          <div class="d-flex">
            <h4>{{ reportingObj?.element?.name }}</h4>
            <ng-container [ngSwitch]="selectedField">
              <small *ngSwitchCase="'mediumGroup'">{{ 'lang.globals.motiveGroup' | translate }}</small>
              <small *ngSwitchCase="'medium'">{{ 'lang.globals.medium' | translate }}</small>
              <small *ngSwitchCase="'product'">{{ 'lang.globals.product' | translate }}</small>
              <small *ngSwitchCase="'productCategory'">{{ 'lang.globals.productCategory' | translate }}</small>
            </ng-container>

          </div>
        </div>
        <div class="card-body d-flex justify-content-between align-items-center">
          <div class="text-center" *ngIf="selectedField === 'mediumGroup'">
            <h5>{{ reportingObj?.element?.mediaCount }}</h5>
            <p class="text-muted">{{ 'lang.reporting.motivesInGroup' | translate }}</p>
          </div>
          <div class="text-center">
            <h5>{{ util.modifiedCheck(reportingObj?.element)?.toString() | date : 'dd.MM.yy HH:mm' }}</h5>
            <p class="text-muted">{{ 'lang.globals.modifiedAt' | translate }}</p>
          </div>
          <div class="text-center">
            <h5>{{ reportingObj?.element?.createdBy ? reportingObj?.element?.createdBy?.name : 'Unknown' }}</h5>
            <p class="text-muted">{{ 'lang.globals.creator' | translate }}</p>
          </div>
        </div>
        <div *ngIf="selectedField === 'mediumGroup'" class="card-footer py-4">

          <div class="row">
            <div class="col-12 text-center px-5">
              <a class="w-100" target="_blank" [sbRouterLink]="util.RoutingID.mediumGroupEdit"
                 [pathParams]="[{id: 'mediumGroupID', value: this.reportingObj?.element?.id}]">
                <button class="btn btn-primary glow ">{{
                    'lang.reporting.showMotiveGroup' |
                      translate
                  }}
                </button>
              </a>
              <!-- <button class="btn btn-primary glow " (click)="removeElement()">Show Overview</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!--  <div class="col-md-2">
        <sb-card classes="no-border">
          <div card-header classes="no-border">
            <h3>{{'lang.shareOfVoice.shareOfVoiceInTotal' | translate}}</h3>
            <small>{{'lang.shareOfVoice.groupedByGender' | translate}}</small>
          </div>
          <div card-fit>
            <sb-chart chartType="pieChart" *ngIf="pieChart?.loadingDone && loading === false" [chartData]="pieChart"></sb-chart>
          </div>
        </sb-card>
      </div>-->
    <div class="col-md-6 col-12">
      <sb-card>
        <div classes="no-border" card-header>
          <h3>{{ 'lang.reporting.playoutsPerDay' | translate }}</h3>
        </div>
        <div card-header-more>
          <div class="font-weight-normal text-end" style="font-size: 12px" #playerLineChartLegend></div>
        </div>
        <div classes="overflow-hidden" card-body>
          <sb-chart #playerLineChart chartType="lineChart" [chartData]="playerLineChartData"></sb-chart>
        </div>
      </sb-card>
    </div>
    <div class="col-md-6 col-12">
      <sb-card>
        <div card-header classes="no-border">
          <h3>{{ 'lang.reporting.playoutsPerHour' | translate }}</h3>
        </div>
        <div card-body>
          <sb-chart #playerHeatmap chartType="heatmap" [chartData]="playerHeatmapData"></sb-chart>
        </div>
      </sb-card>
    </div>
    <div class="col-md-6 col-12">

      <sb-card>
        <div card-header classes="no-border">
          <h3>{{ 'lang.globals.visitorsPerDay' | translate }}</h3>
        </div>
        <div card-header-more>
          <div class="font-weight-normal text-end" style="font-size: 12px" #visitorLineChartLegend></div>
        </div>
        <div card-body>
          <sb-chart #visitorLineChart chartType="lineChart" [chartData]="visitorLineChartData"></sb-chart>
        </div>
      </sb-card>
    </div>

    <div class="col-md-6 col-12">
      <sb-card>
        <div card-header classes="no-border">
          <h3>{{ 'lang.globals.visitorPerHour' | translate }}</h3>
        </div>
        <div card-body>
          <sb-chart #visitorHeatmap chartType="heatmap" [chartData]="visitorHeatmapData"></sb-chart>
        </div>
      </sb-card>
    </div>

  </div>
</ng-container>
